// extracted by mini-css-extract-plugin
export default {"custom_button":"Button_custom_button__z5jHT","link":"Button_link__VToRE"};